import React, { FC } from 'react';
import { Row, Col } from 'antd';
import InputField from 'shared/components/InputField';
import styles from '../../activityDataEntry.module.scss';
import { Scope1DesiredData } from 'models/ActivityDataScope1DesiredData/scope1DesiredData.model';
import { HelpDeskInputFieldEnum } from 'context/HelpDeskTooltipContext/helpDeskInputFieldEnum';
import { useFormikContext } from 'formik';
import { ScopeData } from 'models/ActivityDataEntryScopes/scopes.model';
import { convertToReadableText } from 'shared/utils/convertToUserReadable';
import { allowOnlyNumbers } from 'shared/utils/convertFormData';

interface MobileSourcesFieldsProps {
  handleToolTipOpen: (fieldName: HelpDeskInputFieldEnum) => () => void;
  isEditView: boolean;
  handleMonthlyModalOpen: (
    source?: ScopeData,
    key?: string,
    selectedIndex?: string
  ) => () => void;
  handleSwitch: (
    source?: ScopeData,
    key?: string,
    selectedIndex?: string,
    selectedItemIndex?: number
  ) => () => void;
}

const MobileSourcesFields: FC<MobileSourcesFieldsProps> = ({
  handleToolTipOpen,
  isEditView,
  handleMonthlyModalOpen,
  handleSwitch,
}) => {
  const { values } = useFormikContext<Scope1DesiredData>();
  return (
    <Row gutter={[24, 40]} className={styles.mobileSourceFormConatiner}>
      {values?.mobileSources?.map((source, index) => (
        <Col span={12} key={source?.fuelName}>
          <div className={styles.fieldContainer}>
            <Col span={values?.mobileSources?.[index].isYearly ? 16 : 9}>
              <InputField
                name={`mobileSources.${index}.fuelValue`}
                placeholderstring={source?.getPlaceholder?.() ?? ''}
                label={source?.getPlaceholder?.() ?? ''}
                info
                infoClick={handleToolTipOpen(
                  convertToReadableText(
                    source?.fuelName
                  ) as HelpDeskInputFieldEnum
                )}
                disabled={
                  !isEditView || !values?.mobileSources?.[index].isYearly
                }
                onKeyDown={allowOnlyNumbers}
                isNullable={true}
              />
            </Col>
            {!values?.mobileSources?.[index].isYearly && (
              <>
                <Col span={7}>
                  <p
                    className={styles.viewMonthlyText}
                    onClick={handleMonthlyModalOpen(
                      values?.mobileSources?.[index],
                      'mobileSources',
                      `mobileSources.${index}`
                    )}>
                    View Monthly data
                  </p>
                </Col>
                {isEditView && (
                  <span className={styles.pipeSeperator}> | </span>
                )}
              </>
            )}
            {isEditView && (
              <Col span={8}>
                <p
                  className={styles.monthlyText}
                  onClick={handleSwitch(
                    values?.mobileSources?.[index],
                    'mobileSources',
                    `mobileSources.${index}`
                  )}>
                  {values?.mobileSources?.[index].isYearly
                    ? 'Switch to monthly'
                    : 'Switch to annually'}
                </p>
              </Col>
            )}
          </div>
        </Col>
      ))}
    </Row>
  );
};

export default MobileSourcesFields;
